import React, { useEffect, useState } from "react";
import DashBoardMobileServices from "../../components/DashBoard/DashBoardMobile/DashBoardMobileServices";
import { useTripsCtx } from "../../context/TripDetailsContext";
import { useParams } from "react-router-dom";

interface IParams {
  type: string;
}
const ProfileMobileContainer: React.FC = () => {
  const {
    upcomingTripDetailsCtx,
    pastTripDetailsCtx,
    favoriteTripDetailsCtx,
  } = useTripsCtx();
  const [upcomingTripDetails] = upcomingTripDetailsCtx;
  const [pastTripDetails] = pastTripDetailsCtx;
  const [favoriteTripDetails] = favoriteTripDetailsCtx;

  const params = useParams<IParams>();

  return (
    <DashBoardMobileServices
      serviceType={params.type}
      upcomingTripDetails={upcomingTripDetails}
      pastTripDetails={pastTripDetails}
      favoriteTripDetails={favoriteTripDetails}
    />
  );
};
export default ProfileMobileContainer;
